import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UIMonetaryAmount } from '@ui/components';

@Component({
  selector: 'shared-card-financials',
  templateUrl: './card-financials.component.html',
  styleUrls: ['./card-financials.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SharedCardFinancialsComponent {
  readonly requestedAmount = input.required<UIMonetaryAmount>();
  readonly approvedAmount = input.required<UIMonetaryAmount>();
  readonly isPaid = input<boolean>(false);
}
